import React, { useEffect, useRef } from 'react';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export type QtyBreaksDropdownProps = {
    title: string,
    expand: boolean,
    small?: boolean,
    onClick: Function,
    skuTable?: boolean,
    areAllRowsExpanded?: boolean
}

export const QtyBreaksDropdown = (props: QtyBreaksDropdownProps) => {

    const focusDiv: any = useRef();
    useEffect(() => {
        if (focusDiv.current && window.innerWidth > 768 && props.skuTable && !props.areAllRowsExpanded) {
            focusDiv.current.focus();
        }
    }, [focusDiv, props.areAllRowsExpanded, props.skuTable]);

    return (
        <>
            <div tabIndex={0} ref={focusDiv} className={`qty-breaks-dropdown badge badge-pill badge-warning${props.small ? " small" : ""}`} onKeyPress={(e) => props.onClick(e)} onClick={(e) => props.onClick(e)}>
                <span>{props.title}</span>
                {props.expand ? <ExpandLessIcon className='icon-red' /> : <ExpandMoreIcon className='icon-red' />}
            </div>
        </>
    );
};